import { navigate } from 'gatsby';

interface LocationType {
  search: string;
}

export const getPageId = (location: LocationType) =>
  parseInt(new URLSearchParams(location?.search)?.get('page') ?? '1', 10) - 1;

export const changePage = (page: number, location: LocationType): void => {
  const searchParams = new URLSearchParams(location?.search);

  searchParams.set('page', page.toString());
  const newSearch = `?${searchParams.toString()}`;
  if (newSearch !== location.search) navigate(newSearch);
};
